import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { equipQuality } from 'actions/myself';
import { fetchProfile } from 'actions/profile';
import Image from 'components/Image';
import QualityPicker from 'components/QualityPicker';
import categoryNameToHumanReadableCategoryName from 'utils/categoryNameToHumanReadableCategoryName';

import getQualityPickerQualities from 'selectors/profile/getQualityPickerQualitiesByCategory';
import { IAppState } from 'types/app';
import { IQuality } from 'types/qualities';
import { IProfileCharacter } from 'types/profile';

interface State {
  isChanging: boolean,
  isQualityPickerOpen: boolean,
}

export class ProfileInventoryItemComponent extends Component<Props, State> {
  static displayName = 'ProfileInventoryItemComponent';

  state = {
    isChanging: false,
    isQualityPickerOpen: false,
  };

  handleChoose = async ({ id }: { id: number }) => {
    const { dispatch, profileCharacter: { name: profileName } } = this.props;
    this.setState({ isChanging: true });
    await dispatch(equipQuality(id));
    await dispatch(fetchProfile(profileName));
    this.setState({ isChanging: false });
  };

  handleClick = () => {
    const { editable } = this.props;
    if (!editable) {
      return;
    }
    this.setState({ isQualityPickerOpen: true });
  };

  handleRequestClose = () => {
    this.setState({ isQualityPickerOpen: false });
  };

  render = () => {
    const {
      data,
      editable,
      qualityPickerQualities,
    } = this.props;

    const {
      isChanging,
      isQualityPickerOpen,
    } = this.state;

    const {
      availableAt,
      category,
      description,
      id,
      image,
      name,
    } = data;

    const categoryName = categoryNameToHumanReadableCategoryName(category);

    const tooltipData = {
      ...data,
      description: `<p>${description}</p>${data.availableAt ? `<p class="tooltip__available-at">${availableAt}</p>` : ''}`,
      level: undefined,
    };

    return (
      <Fragment>
        <li
          data-quality-id={id}
          className={classnames(
            'profile__inventory-item',
            editable && 'profile__inventory-item--editable',
            isChanging && 'icon--is-loading',
          )}
        >
          <Image
            icon={image}
            alt={name}
            type="small-icon"
            tooltipData={tooltipData}
            onClick={this.handleClick}
            defaultCursor={!editable}
          />
        </li>
        {editable && (
          <QualityPicker
            activateButtonLabel="Equip"
            header={`Equip your new ${categoryName}`}
            isOpen={isQualityPickerOpen}
            onChoose={this.handleChoose}
            onRequestClose={this.handleRequestClose}
            qualities={qualityPickerQualities}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state: IAppState, props: OwnProps) => ({
  qualityPickerQualities: getQualityPickerQualities(state, props),
});

interface OwnProps {
  data: IQuality,
  editable: boolean,
  profileCharacter: IProfileCharacter,
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & { dispatch: Function };

export default connect(mapStateToProps)(ProfileInventoryItemComponent);